const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'fqdn', label: 'URL', sortable: true },
    { key: 'last_visit', label: 'Last Visit', sortable: true },
    { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'name', label: '이름', sortable: true },
    { key: 'fqdn', label: 'URL', sortable: true },
    { key: 'last_visit', label: '최근 방문', sortable: true },
    { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'name', label: '名前', sortable: true },
    { key: 'fqdn', label: 'URL', sortable: true },
    { key: 'last_visit', label: '最終訪問', sortable: true },
    { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const _i18n_info = {
  recently: {
    EN: `recently checked site scan`,
    KO: `recently checked site scan`,
    JP: `最近チェックしたサイトをスキャン"`
  }
}

const _i18n_warning = {
  snapshot : {
    EN: `We recommend no more than 10 for traffic.`,
    KO: `We recommend no more than 10 for traffic.`,
    JP: `トラフィックを考えると 10 以下にすることをお勧めします`
  },
  hash_remove : {
    EN: `remove duplicate`,
    KO: `remove duplicate`,
    JP: `重複を削除する`
  },
  integrity_select : {
    EN: `no have setting`,
    KO: `no have setting`,
    JP: `設定はありません`
  },
}

const _i18n_error = {
  failed : {
    EN: `faild`,
    KO: `faild`,
    JP: `失敗`
  },
  data_failed : {
    EN: `data saving failed`,
    KO: `data saving failed`,
    JP: `データ保存に失敗しました`
  },
  load_failed : {
    EN: `loading failed`,
    KO: `loading failed`,
    JP: `ロードに失敗しました`
  },
  result : {
    EN: `recent scanning is no pages`,
    KO: `recent scanning is no pages`,
    JP: `最近のスキャンページはありません`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_info,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data